/**
 * 消息组件
 */

import {h, Component} from 'preact';
import './message.scss';

import ReceiveWrap from './receive-wrap/receive-wrap';
import SendWrap from './send-wrap/send-wrap';
import SDK from 'lib/sdk';
import {getLocalTime, parseFace} from 'lib/util';
import FaceMap from 'lib/emoji-map';
import MsgStatus from './msg-status/msg-status';

const ROLE_WRAP = {
  'send': SendWrap,
  'receive': ReceiveWrap
};

export default class Message extends Component{
  constructor(props){
    super(props);
    this.state = {
      tipName: 'isHelp',
      status: props.isStorage ? 'complete' : 'loading'
    }
  }
  
  componentWillMount(){
    if(!this.props.isStorage){
      this.sendMsg();
    }
  }

  sendMsg(){
    this.setState({
      status: 'loading'
    });

    // 发送前做表情解析
    let msg = parseFace(FaceMap, this.props.msgData);

    SDK.send(msg, (err, status)=>{
      if(err){
        return this.setState({
          status: 'err'
        });
      };

      if(status.status_code === 0){
        this.setState({
          status: 'complete'
        })
      }else{
        this.setState({
          status: 'err'
        })
      }
    });
  }

  sendQuestion(question){
    SDK.appendMsg(question);
  }

  sendFeedback(value){
    if(value === 1){
      this.setState({
        tipName: 'thanks'
      })
    }else{
      this.setState({
        tipName: 'sorry'
      })
    }

    SDK.feedBack(this.props.msgId, value);
  }

  vOnline(){
    return (
      <span 
        class='online__service--link'
        onClick={()=>{SDK.gotoStaffService()}}
      >
        人工服务
      </span>
    );
  }

  vFeedback(){
    if(this.state.tipName === 'isHelp'){
      return (
        <div class='msg__options--list'>
          <span class='msg__options--item' onClick={this.sendFeedback.bind(this, 1)}>有帮助</span>

          <span class='msg__options--item' onClick={this.sendFeedback.bind(this, -1)}>没帮助</span>
        </div>
      )
    }
  }

  vTime(time){
    return (
      <p class='msg__time'>
        {getLocalTime(+time)}
      </p>
    )
  }

  vContent(msg, overturn){
    if(!msg && overturn === 1){
      return (
        <p class='msg__content'>
          您好，你的问题暂未找到答案，请更换描述重试，或切换为
          {this.vOnline()}
        </p>
      )
    }

    // 格式处理
    msg = msg.replace(/\n/g, " <br /> ");
    msg = msg.replace(/\[br\]/g,' <br/> ');
    
    // 做表情解析
    msg = parseFace(FaceMap, msg);

    return (
      <p class='msg__content' dangerouslySetInnerHTML={{__html: msg}} />
    )
  }

  vOtherAnswer(detail){
    if(!detail || detail.similarQuestion.length === 0){
      return;
    }

    return (
      <section class='msg__other--wrap'>
        <h2 class='msg__other--title'>点击可了解更多问题：</h2>
        <ul class='msg__other--list'>
          {
            detail.similarQuestion.map((item)=>{
              return (
                <li class='msg__ohter--item'>
                  <span onClick={this.sendQuestion.bind(this, item)}>
                    {item}
                  </span>
                </li>
              )
            })
          }
        </ul>
      </section>
    )
  }

  vSeedback(needFeedback){
    // 1 需要 0 不需要
    if(needFeedback === 0){
      return;
    }

    let tips = {
      sorry: '如未能解决问题，请您更换问题描述或切换到',
      thanks: '感谢您对小微的支持。',
      isHelp: '小微是否有帮到你？'
    };

    return (
      <footer class='msg__options'>
        <p>
          {tips[this.state.tipName]}{this.state.tipName === 'sorry' && this.vOnline()}
        </p>

       {this.vFeedback()}
      </footer>
    )
  }

  render(props, state){
    let Wrap = ROLE_WRAP[props.role]

    return (
      <div class='message'>
        {props.showTime && this.vTime(props.time)}

        <Wrap   
          session={props.session} 
          status={state.status}
          onErrClick={this.sendMsg.bind(this)}
        >
          {this.vContent(props.msgData, props.overturn)}
          {this.vOtherAnswer(props.detail)}
          {this.vSeedback(props.needFeedback)}
        </Wrap>
      </div>
    )
  }
}


/** WEBPACK FOOTER **
 ** ./components/message/message.jsx
 **/